import clsx from 'clsx';
import { Formik } from 'formik';
import React, { useMemo } from 'react';
import { Form } from 'react-bootstrap';

import { useTeamSubscriptionCreate } from '../../../hooks';
import { useTeamUserCreate } from '../../../hooks';
import { Button } from '../../BaseUI';
import { TextField } from '../../FormFields';
import schema from './schema';
import styles from './styles.module.scss';

const EmailForm = ({
  companyName,
  currentUserEmail,
  guid,
}: {
  companyName: string;
  currentUserEmail: string;
  guid: string;
}) => {
  const { mutate: createTeamSubscription, isLoading: isCreateTeamSubscriptionLoading } =
    useTeamSubscriptionCreate();
  const {
    mutateAsync: createTeamUser,
    isError,
    isLoading: isCreatUserLoading,
  } = useTeamUserCreate();

  const initialState = useMemo(
    () => ({
      email: currentUserEmail || '',
    }),
    [currentUserEmail]
  );
  const handleSubmit = async ({ email }) => {
    if (!currentUserEmail) {
      await createTeamUser({ user: { email, skipVerifyTeamDomain: true } });
      if (!isError) {
        createTeamSubscription({ guid });
      }
    } else {
      createTeamSubscription({ guid });
    }
  };

  return (
    <div className="container">
      <div className={clsx(styles.formWrapper, 'row')}>
        <div className={clsx(styles.headerContainer, styles.companyName)}>{companyName}</div>

        <div className={styles.headerContainer}>
          <div className={styles.headerWrapper}>
            {currentUserEmail ? (
              <span>To activate your corporate subscription click button below to continue</span>
            ) : (
              <span>
                To activate your corporate subscription please enter your corporate email address
              </span>
            )}
          </div>
        </div>
        <Formik
          enableReinitialize
          initialValues={initialState}
          onSubmit={handleSubmit}
          validationSchema={schema}
        >
          {(formik) => (
            <Form noValidate onSubmit={formik.handleSubmit} className={styles.formContainer}>
              {currentUserEmail ? (
                <div className={styles.headerContainer}>{currentUserEmail}</div>
              ) : (
                <TextField name="email" placeholder="Enter your corporate email" />
              )}
              <div className={styles.buttonContainer}>
                <Button
                  variant="primary"
                  type="submit"
                  disabled={!currentUserEmail && !(formik.isValid && formik.dirty)}
                  width="full"
                >
                  {isCreateTeamSubscriptionLoading || isCreatUserLoading
                    ? 'Processing'
                    : 'Continue with Email'}
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default EmailForm;
